/*******************************************************
OPEN WIN RATE MODAL
Used on the win rate page for NFL.
********************************************************/

import buildModal from '../../universal/modal-window/build-modal';

export default function openWinRateModal(event) {
    const $button = $(event.currentTarget);
    const { id, playerid, firstname, lastname, pos, team, startweek, endweek } = $button.data();

    // Get the table data
    let $activeTab = $('.bestball:not(.hide-filtertab)').data('pos').toUpperCase();
    let tableID = $('#bestball'+$activeTab).find('.webix_dtable').attr('id');
    let table = $$(tableID);
    let $rowData = table.getItem(id);

    // Build label name + bar data
    let $weeks = [];
    let $percentages = [];
    let $barColor = [];
    let $borderColor = [];
    for (let i = startweek; i <= endweek; ++i) {
        $weeks.push(i);
        $percentages.push($rowData['wk'+i]);
        $barColor.push('rgba(18, 108, 211, 0.2)');
        $borderColor.push('rgba(18, 108, 211, 1)');
    }

    // Build the title
    const modalTitle = `
    <div class="flex-row align-center">
        <img style="width:35px;margin-right:10px;" src="https://content.rotowire.com/images/teamlogo/football/100${team}.png"> ${firstname} ${lastname}
    </div>`;

    // Build the content of the modal
    const modalContent = `
    <div style="">
        <canvas id="myChart" class="pad-5-5"></canvas>
    </div>`;

    // Get the modal window HTML
    const modalHTML = buildModal({
        title    : modalTitle,
        content  : modalContent,
    });

    // Append the modal window to the page
    $('.page').append(modalHTML);

    // Add bar chart
    var ctx = document.getElementById('myChart').getContext('2d');
    var myChart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: $weeks,
            datasets: [{
                data: $percentages,
                backgroundColor: $barColor,
                borderColor: $borderColor,
                borderWidth: 1
            }]
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'Win Rate %',
                        fontSize: 12,
                        fontColor: '#000',
                        fontStyle: 'bold',
                    },
                }],
                xAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Weeks',
                        fontSize: 12,
                        fontColor: '#000',
                        fontStyle: 'bold',
                    },
                }],
            },
            title: {
                display: true,
                text: 'Win Rate By Week',
                fontSize: 15,
                fontColor: '#000',
                fontStyle: 'bold',
            },
            legend: {
                display: false,
            }
        }
    });

}
